// --- Display (credit card strip, ban details popup, select item) ---

export const getUpdatePaymentBanStripLabel = (selectedBans) => {
  const count = selectedBans?.length ?? 0;
  if (count === 1) {
    return `חשבון לעדכון ${selectedBans[0].banNumber}`;
  }
  return `${count} חשבונות נבחרו לעדכון`;
};

// --- Ban select step (SelectUpdatePaymentBan) ---

/** Bans eligible for update-payment multi-select. Excludes energy and accounts with debt. */
export const getEligibleBansForUpdatePaymentSelect = (allBans) => (allBans ?? []).filter((ban) => !ban.isEnergy && !ban.hasDebt);

/** Skip ban-select step when only one eligible ban exists and it is the current selection. */
export const isSingleEligibleBanAlreadySelected = (allBans, selectedBanNumber) => {
  const eligible = getEligibleBansForUpdatePaymentSelect(allBans);
  return eligible.length === 1 && eligible[0].banNumber === selectedBanNumber;
};

/** True when the customer has non-energy accounts with debt (hidden from the list). */
export const hasHiddenDebtBans = (allBans) => (allBans ?? []).some((ban) => !ban.isEnergy && ban.hasDebt);

/** True when at least one account has debt. */
export const hasAnyBanWithDebt = (allBans) => (allBans ?? []).some((ban) => ban.hasDebt);

/**
 * Display order:
 * 1. No debt, no payment method (hasPaymentMethodIssue)
 * 2. No debt, with payment method
 * Selected ban is shown first when it appears in the list.
 */
export const buildDisplayBansForUpdatePaymentSelect = (allBans, selectedBanNumber) => {
  const eligible = getEligibleBansForUpdatePaymentSelect(allBans);
  const withoutPaymentMethod = eligible.filter((ban) => ban.hasPaymentMethodIssue);
  const withPaymentMethod = eligible.filter((ban) => !ban.hasPaymentMethodIssue);
  const ordered = [...withoutPaymentMethod, ...withPaymentMethod];

  if (!selectedBanNumber) {
    return ordered;
  }

  const selected = ordered.find((ban) => ban.banNumber === selectedBanNumber);
  if (!selected) {
    return ordered;
  }

  return [selected, ...ordered.filter((ban) => ban.banNumber !== selectedBanNumber)];
};
